"use client";

import { iHolidayQuoteX } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { QuoteContentSection } from "../content-section";
import { TripModeItinerarySection } from "./trip-mode-itinerary-section";
import { TripModeSectionNav } from "./trip-mode-section-nav";

export interface TripModePageContentProps {
  quote: iHolidayQuoteX;
  pricingMode?: "grid" | "grid-asymmetric" | "sidebar";
}

export function TripModePageContent({
  quote,
  pricingMode = "grid",
}: TripModePageContentProps) {
  const storyAndDays = (
    <>
      <div id="trip-section-story" className="scroll-mt-28 space-y-8">
        <QuoteContentSection blocks={quote.preItineraryBlocks} />
      </div>
      <TripModeItinerarySection itinerary={quote.itineraryBlocks || []} />
      <div id="trip-section-more" className="scroll-mt-28">
        <QuoteContentSection blocks={quote.postItineraryBlocks} />
      </div>
    </>
  );

  const pricingColumn = (
    <div id="trip-section-pricing" className="scroll-mt-28 space-y-8">
      <QuoteContentSection blocks={quote.pricingBlocks} />
      <QuoteContentSection blocks={quote.postPricingBlocks} />
    </div>
  );

  const nav = <TripModeSectionNav quote={quote} />;

  if (pricingMode === "sidebar") {
    return (
      <div className="mx-auto grid max-w-screen-xl gap-8 px-4 py-8 lg:grid-cols-[minmax(0,320px)_minmax(0,1fr)]">
        <aside className="space-y-8 lg:sticky lg:top-20 lg:self-start">
          {pricingColumn}
        </aside>
        <div className="space-y-8">
          {nav}
          {storyAndDays}
        </div>
      </div>
    );
  }

  if (pricingMode === "grid-asymmetric") {
    return (
      <div className="mx-auto max-w-screen-xl space-y-8 px-4 py-8">
        {nav}
        {storyAndDays}
        <div
          id="trip-section-pricing"
          className="scroll-mt-28 grid grid-cols-1 gap-8 lg:grid-cols-[7fr_13fr]"
        >
          <div className="space-y-8">
            <QuoteContentSection blocks={quote.pricingBlocks} />
          </div>
          <div className="space-y-8">
            <QuoteContentSection blocks={quote.postPricingBlocks} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-screen-xl space-y-8 px-4 py-8">
      {nav}
      {storyAndDays}
      <div
        id="trip-section-pricing"
        className="scroll-mt-28 grid grid-cols-1 gap-8 lg:grid-cols-2"
      >
        <div className="space-y-8">
          <QuoteContentSection blocks={quote.pricingBlocks} />
        </div>
        <div className="space-y-8">
          <QuoteContentSection blocks={quote.postPricingBlocks} />
        </div>
      </div>
    </div>
  );
}
